interface LogoProps {
    className?: string
}

const Logo: React.FC<LogoProps> = ({ className = '' }) => {
    return (
        <div className={`text-primary ${className}`}>
            <img src="/images/icon.png" className="w-full h-full" />
        </div>
    )
}

export default Logo
